import { render, staticRenderFns } from "./HtTableColumn.vue?vue&type=template&id=2b3be486&"
import script from "./HtTableColumn.vue?vue&type=script&lang=js&"
export * from "./HtTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports